'use client';

import { useEffect, useRef } from 'react';

import { useFinance } from '@/hooks/finance/finance.hook';

const DealnetFinance = () => {
  const { selectedFinance } = useFinance();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    const apiKey = process.env.NEXT_PUBLIC_DEALNET_API_KEY;

    const sdkUrl = process.env.NEXT_PUBLIC_DEALNET_SDK_URL;

    if (!apiKey || !sdkUrl) {
        console.error(
            '[Dealnet] Missing required configuration: API key or SDK URL.',
        );
        return;
    }

    const handleDealnetEvent = (event: Event) => {
      const customEvent = event as CustomEvent;
      const detail = customEvent.detail;

      // eslint-disable-next-line no-console
      console.log('[Dealnet] Event:', detail?.type);
      // eslint-disable-next-line no-console
      console.log('[Dealnet] Application Message:', detail?.message);

      if (detail?.type === 'completed') {
        // eslint-disable-next-line no-console
        console.log(
          '[Dealnet] Application completed:',
          detail.applicationId,
        );
      }
    };

    window.addEventListener('dealnet:event', handleDealnetEvent);

    const script = document.createElement('script');

    script.id = 'dealnet-finance-script';
    script.type = 'text/javascript';
    script.src = sdkUrl;
    script.async = true;

    script.dataset.apiKey = apiKey;
    script.dataset.returnUrlCode = process.env.NEXT_PUBLIC_DEALNET_RETURN_URL_CODE ?? '';
    script.dataset.container = 'financeApp';
    script.dataset.theme = 'light';
    script.dataset.mmCode = String(selectedFinance?.mmCode ?? '');
    script.dataset.dealerId = process.env.NEXT_PUBLIC_DEALNET_DEALER_ID;
    script.dataset.dealerRef = selectedFinance?.dealerRef;
    script.dataset.source = process.env.NEXT_PUBLIC_DEALNET_SOURCE;

    container.appendChild(script);

    return () => {
      window.removeEventListener('dealnet:event', handleDealnetEvent);
      script.remove();
      container.replaceChildren();
    };
  }, [selectedFinance?.mmCode, selectedFinance?.dealerRef]);

  return <div id="financeApp" ref={containerRef} />;
};

export default DealnetFinance;
